<template>
  <div id="app">
    <Header key="header" titulo="Simulá tu préstamo"/>
    <transition-group name="fade" v-if="!loading">
      <Acordeon key="preciosA" :listaPrecios="listaPrecios" :concesionarias="concesionarias" :vigencia="vigencia" :entorno="entorno" :query="modelo"/>
    </transition-group>
    <div class="container" v-else>
      <p class="intro-copy">Cargando...</p>
    </div>
  </div>
</template>

<script>
import Header from "./components/Header";
import Acordeon from "./components/Acordeon";
import axios from "axios";

/* eslint-disable */
const API_URL = "https://precios.vwcontenidos.com.ar/api";

export default {
  name: "app",
  components: {
    Header,
    Acordeon
  },
  data() {
    return {
      loading: true,
      listaPrecios: [],
      concesionarias: [],
      vigencia: '',
      modelo: null,
      entorno: 'prod'
    };
  },
  mounted: function () {
    this.modelo = this.getParameterByName('q');
    this.entorno = this.getParameterByName('env') && this.getParameterByName('env') == 'qa' ? 'qa' : 'prod';
    axios.get(API_URL + "/modelos").then(response => {
      this.listaPrecios = response.data;
      this.loading = false;
      document.title = "Financial Services | Volkswagen Argentina";
    });
    axios.get(API_URL + "/ventas").then(response => {
      this.vigencia = response.data.vigencia;
    });
    axios.get("https://institucional.vwcontenidos.com.ar/api/informacion/calculadora-financiera").then(response => {
      this.concesionarias = response.data.concesionarias;
    });
  },
  methods: {
    getParameterByName: function (name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[\[\]]/g, '\\$&');
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
          results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }
  }
};
</script>

<style lang="scss">
@import "./assets/scss/_vw-tokens.scss";
@import "./assets/scss/_fonts.scss";

* {
  transition: all 300ms ease-in-out;
}

html,
body {
  background: $vw-bg;
}

body {
  // @media(max-width: 1441px) {
  //   font-size: 12px;
  // }
  // @media(max-width: 1023px) {
  //   font-size: 11px;
  // }
  @media(max-width: 767px) {
    font-size: 10px;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 300ms ease-in-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

:root {
  --textShadow: 0 1px 2px rgba(#000, 0.2);
}

$azul: $vw-blue;

#app {
  font-family: "vw-head", Arial, Helvetica, sans-serif;
  background: $vw-bg;
  color: $vw-content;
  min-height: 1080px;
  position: relative;
  padding: 0 0 7em;
  @media (min-width: 1630px) {
    .container {
      width: 100%;
      max-width: 1630px;
    }
  }

  h1, h2, h3, .intro-copy {
    color: $azul;
  }

  .header__title h1 {
    margin-top: 0;
    font-weight: 700;
    font-size: 3em;
    line-height: 1.2;
    letter-spacing: -0.015em;
  }

  .intro-copy {
    margin: 1.25em auto 0.4em;
    font-size: 2em;
    font-weight: 300;
    color: $azul;
    letter-spacing: -0.015em;
    @media(max-width: 767px) {
      font-size: 1.8em;
    }
  }

  h1 {
    font-size: 3.8em;
    font-weight: 300;
    margin: 0.4em 0 0;
    letter-spacing: -0.02em;
    line-height: 1em;
    @media(max-width: 1441px) {
      font-size: 3.4em;
    }
    @media(max-width: 767px) {
      font-size: 2.4em;
    }
  }

  h2 {
    font-size: 3.8em;
    font-weight: bold;
    line-height: 1em;
    letter-spacing: -0.021em;
    margin: 0.1em 0 0.4em;
    @media(max-width: 1441px) {
      font-size: 3.4em;
      padding-right: 10%;
    }
    @media(max-width: 769px) {
      padding-right: 15%;
      br {
        display: none;
      }
    }
    @media(max-width: 767px) {
      font-size: 2.4em;
    }
  }

  h3 {
    font-size: 2.1em;
    font-weight: 300;
    line-height: 1em;
    letter-spacing: -0.035em;
    margin: 1.6em 0;
    color: $vw-content;
    @media(max-width: 767px) {
      font-size: 2.4em;
    }
  }
}

button:focus {
  box-shadow: none;
}

a:focus-visible,
button:focus-visible {
  outline: none !important;
}

a {
  color: $vw-blue;
  text-decoration: underline;
  text-underline-offset: 0.18em;

  &:hover,
  &:active {
    color: $vw-blue-dark;
  }
}

.btn {
  border-radius: $vw-radius-pill;
  margin: 0.3em 1em;
  font-size: 1.1em;
  padding: 0.4em 2.6em 0.6em;
  letter-spacing: -0.04em;
  transition: none;
  @media(max-width: 767px) {
    font-size: 1.6em;
  }

  &:focus {
    box-shadow: none;
  }

  &:disabled {
    opacity: 0.2;
    pointer-events: none;
  }

  &.blanco {
    color: $vw-blue;
    background: $vw-card;
    border: 1px solid $vw-blue;
  }

  &.azul {
    color: $vw-on-dark;
    background: $vw-blue;
    border: 1px solid $vw-blue;
    @media (orientation: landscape) {
      margin-left: 0.2em;
      padding: 0.4em 2.9em 0.6em;
    }
  }

  &:hover,
  &:active {
    background: $vw-btn-selected;
    border-color: $vw-btn-selected;
    color: $vw-content;
    box-shadow: $vw-shadow-hover;
  }
}

.no-appearance {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}

@supports (-webkit-appearance: none) or (-moz-appearance: none) {
  input[type='checkbox'],
  input[type='radio'] {
    -webkit-appearance: none;
    -moz-appearance: none;
    height: 21px;
    outline: none;
    display: inline-block;
    vertical-align: top;
    position: relative;
    margin: 0;
    cursor: pointer;
    border: 2px solid $vw-blue;
    background: transparent;
    transition: background .3s, border-color .3s, box-shadow .2s;

    &:after {
      content: '';
      display: block;
      left: 0;
      top: 0;
      position: absolute;
      transition: transform var(--d-t, .3s) var(--d-t-e, ease), opacity var(--d-o, .2s);
      background: $vw-blue;
    }

    &:checked {
      --b: var(--active);
      --bc: var(--active);
      --d-o: .3s;
      --d-t: .6s;
      --d-t-e: cubic-bezier(.2, .85, .32, 1.2);
    }

    &:disabled {
      --b: var(--disabled);
      cursor: not-allowed;
      opacity: .9;

      &:checked {
        --b: var(--disabled-inner);
        --bc: var(--border);
      }

      & + label {
        cursor: not-allowed;
      }
    }

    &:hover {
      &:not(:checked) {
        &:not(:disabled) {
          --bc: var(--border-hover);
        }
      }
    }

    &:not(.switch) {
      width: 21px;
      margin-right: 10px;

      &:after {
        opacity: var(--o, 0);
      }

      &:checked {
        --o: 1;
      }
    }

    & + label {
      font-size: 1.2em;
      line-height: 1.4em;
      display: inline-block;
      cursor: pointer;
      margin-left: 4px;
      font-weight: 400;
      @media(max-width: 767px) {
        font-size: 2em;
      }
    }
  }
  .radio {
    display: flex;
    align-items: center;
    margin-bottom: 2.2em;
    @media (max-width: 767px) {
      &.fix {
        display: block;

        input {
          float: left;
          margin-top: 4px;
        }
      }
    }
  }
  input[type='checkbox'] {
    &:not(.switch) {
      border-radius: 0;
      border: 1px solid $vw-blue;
      width: 15px;
      height: 15px;
      min-width: 15px;
      min-height: 15px;
      margin-top: 5px;

      &:after {
        width: 100%;
        height: 100%;
      }

      &:checked {
        background: $vw-blue;
      }
    }

    &.switch {
      width: 38px;
      border-radius: 11px;

      &:after {
        left: 2px;
        top: 2px;
        border-radius: 50%;
        width: 15px;
        height: 15px;
        background: var(--ab, var(--border));
        transform: translateX(var(--x, 0));
      }

      &:checked {
        --ab: var(--active-inner);
        --x: 17px;
      }

      &:disabled {
        &:not(:checked) {
          &:after {
            opacity: .6;
          }
        }
      }
    }
  }
  input[type='radio'] {
    outline: none;
    box-shadow: none;
    border-radius: 50%;

    &:after {
      width: 17px;
      height: 17px;
      border-radius: 50%;
      background: var(--active-inner);
      opacity: 0;
      transform: scale(var(--s, .7));
      background: $vw-blue;
    }

    &:checked {
      --s: .5;
    }
  }
}

.v-select,
.v-select .dropdown-toggle,
.v-select .vs__selected-options,
.v-select input,
.v-select input[type="search"] {
  background: transparent !important;
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active,
textarea:-webkit-autofill,
select:-webkit-autofill {
  -webkit-text-fill-color: $vw-content;
  -webkit-box-shadow: 0 0 0 1000px $vw-bg inset !important;
  box-shadow: 0 0 0 1000px $vw-bg inset !important;
  caret-color: $vw-content;
  transition: background-color 9999s ease-in-out 0s;
}

.v-select .open-indicator::before {
  border-color: #0099da !important;
}

.v-select .selected-tag {
  @media (max-width: 768px) {
    // font-size: 2.3vmax;
  }
}

.v-select .vs__actions {
  padding: 0;
  right: 0;
  top: 5px;
  position: absolute;

  .clear {
    font-size: 17px;
  }
}

.v-select .open-indicator, .v-select .open-indicator:before {
  display: none;
}

.azul {
  color: $vw-blue;
}

.table-main {
  border: none;
  border-collapse: separate;
  border-spacing: 0;
  width: 100%;
  border-spacing: 10px;
  border-collapse: separate;

  td, th {
    border: none;
    border-bottom: 1px solid $vw-border;
    // height: 3.2em;
    // vertical-align:middle;
    vertical-align: top;
    @media(max-width: 1441px) {
      height: 42px;
      max-width: 120px;
    }

    &.fix-col {
      // height: 3.2em;
      @media(max-width: 1441px) {
        height: 42px;
      }
    }

    p {
      font-size: 1.2em;
      margin: 0;
      flex: 1;
      // line-height: 1.3em;
      // overflow: hidden;
      // height: 1.3em;
    }
  }
}

.table-main thead th {
  border: none;
  padding: 15px 0;
  text-align: left;
  border-bottom: 1px solid $vw-blue;
  // height: 4em;
  &.fix-col {
    border: none;
  }
}

.alinear {
  display: flex;
  align-items: center;
  height: 100%;
}

.table-main tbody td {
  color: $vw-content;
  padding: 10px 0;

  .detalle_2 p {
    font-size: 0.9em;
  }

  @media(max-width: 767px) {
    p {
      flex-direction: column-reverse;
      display: flex;
    }
  }
}

.table {
  position: relative;
  margin-top: 1.8em;
}

.table-scroll {
  overflow: auto;
  padding-bottom: 5px;
  @media(max-width: 767px) {
    overflow-x: scroll;
    overflow-y: visible;
    margin-left: 20%;
    width: 80%;
  }
  @media(max-width: 767px) {
    margin-left: 150px;
    width: calc(100% - 150px);
  }
}

.table-main .fix-col {
  left: 0;
  top: auto;
  // width: 20%;
  border: none;
  border-bottom: 1px solid $vw-border;
  @media(max-width: 767px) {
    position: absolute;
    width: 150px;
  }
}

.swal2-popup {
  font-size: 1em;
  border-radius: $vw-radius;
}

#swal2-title {
  line-height: 1.3;
  font-family: "vw-head", Arial, Helvetica, sans-serif;
  font-weight: 200;
}

.swal2-popup .swal2-actions button.swal2-confirm {
  border: none !important;
  border-radius: $vw-radius-pill;
  font-size: 1em;
  padding: 0.5em 2.8em 0.6em;
  letter-spacing: -0.04em;
  color: $vw-on-dark;
  background: $vw-blue;
  margin-bottom: 1em;
  font-family: "vw-head", Arial, Helvetica, sans-serif;
  font-weight: 200;
  transition: background 0.2s, color 0.2s, box-shadow 0.2s;

  &:hover,
  &:active {
    background: $vw-btn-selected;
    color: $vw-content;
    box-shadow: $vw-shadow-hover;
  }

  &:focus-visible {
    outline: 2px solid $vw-focus-ring;
    outline-offset: 2px;
  }
}

#swal2-content a.btn {
  border: 1px solid $vw-blue;
  border-radius: $vw-radius-pill;
  font-size: 1.2em;
  padding: 0.6em 2.8em;
  letter-spacing: -0.04em;
  color: $vw-blue;
  background: $vw-card;
  margin-bottom: 1em;
  transition: background 0.2s, color 0.2s, box-shadow 0.2s;

  &:hover,
  &:active {
    background: $vw-btn-selected;
    border-color: $vw-btn-selected;
    color: $vw-content;
    box-shadow: $vw-shadow-hover;
  }

  &:focus-visible {
    outline: 2px solid $vw-focus-ring;
    outline-offset: 2px;
  }
}

.swal2-popup #swal2-content {
  font-size: 1.1em;
}
</style>